module.exports = __webpack_public_path__ + "media/react/schools/app/assets/magoosh-logo-white-9e1a8d0a0ceb903382bd2002410621f5.png";